// tslint:disable:max-line-length triple-equals
import { ButtonMedium } from './../../app/common/sharedComponents/buttons/ButtonMedium';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import { ButtonBlockRow } from './../../app/common/sharedStyledComponents/GenericStyles.styled';
import { ButtonContainer, ButtonSaveContainer } from './Settings.styled';
import ControlInput from 'lqa-ui/lib/Components/ControlInput';
import Icon from 'lqa-ui/lib/Components/Icon';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../helpers/showMessage';
import { clear, getItem, removeItem } from '../../utils/localStorage';
import { deleteMembershipDelete, updatePassword } from './apicaller';
import './styles.scss';
import { useTranslation } from 'react-i18next';
import { PASSWORD_REGEX } from '../../utils/regex';
import { ClearAllIndexedDB } from '../../../src/indexed';
import MemberShipDeleteButton from './MemberShipDeleteButton';
import Block from 'lqa-ui/lib/Components/Block';
import PhoneInput from 'react-phone-input-2';
import { logOutUser } from '../../requests/login';
import { TextInput } from '../../app/common/sharedComponents/TextInput';
import { PhoneContainer } from './../../app/common/sharedStyledComponents/PhoneInput.styled';
import { DropdownSingle } from '../../app/common/sharedComponents/DropdownSingle';
import { IDropdownOption } from '../../app/@types/dropdown';

const Settings = () => {
  // Change this to props value and use it in Security.tsx for adding future references
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userData = getItem('user');
  const userLoginEmail = getItem('login-email');
  const userLoginPhone = getItem('login-phone');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailSelected, setIsEmailSelected] = useState('');
  const [isPasswordValidated, setIsPasswordValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const isEmailExist = getItem('login-email');
  const [showBox, setShowBox] = useState(false);
  const userProfile = getItem('userProfile');
  const membershipCode =
    userProfile &&
    userProfile.membershipCode &&
    userProfile.membershipCode != null &&
    userProfile.membershipCode !== 'NULL'
      ? userProfile.membershipCode
      : undefined;
  const personalEmail =
    userProfile &&
    userProfile.userEmail &&
    userProfile.userEmail != null &&
    userProfile.userEmail !== 'NULL'
      ? userProfile.userEmail
      : undefined;
  const selectedHotelId = getItem('selectedHotel');
  const selectedClientId = getItem('selectedClient');

  useEffect(() => {
    if (
      newPassword !== confirmNewPassword ||
      !PASSWORD_REGEX.test(confirmNewPassword) ||
      newPassword.length < 8
    ) {
      setIsPasswordValidated(false);
    } else {
      setIsPasswordValidated(true);
    }
  }, [currentPassword, newPassword, confirmNewPassword]);

  const handleSave = () => {
    setIsLoading(true);
    const payload: any = {
      oldpassword: currentPassword,
      newpassword: newPassword,
    };
    if (
      (userLoginEmail && userLoginEmail.includes('@')) ||
      (isEmailSelected && isEmailSelected.includes('@'))
    ) {
      payload.username = userLoginEmail ? userLoginEmail : isEmailSelected;
    } else {
      payload.userphone = userLoginPhone
        ? '+' + String(userLoginPhone)
        : String(isEmailSelected);
    }
    let loginCred: string = '';
    updatePassword(payload)
      .then(() => {
        showSuccessMessage('Password has been updated');
        setIsLoading(false);

        // await disablePushNotifications();
        ClearAllIndexedDB();
        const userData = getItem('user');
        const accessToken = userData.accessToken;
        clear();
        if (payload.username) {
          localStorage.setItem('email', payload.username.trim().toLowerCase());
          loginCred = 'email';
        } else if (payload.userphone) {
          localStorage.setItem(
            'phonenumber',
            userLoginPhone || isEmailSelected
          );
          loginCred = 'phone';
        }

        localStorage.setItem('selectedHotel', selectedHotelId);
        localStorage.setItem('selectedClient', selectedClientId);
        logOutUser(accessToken)
          .then((res) => {
            navigate('/register-success/updated');
          })
          .catch((err) =>
            showErrorMessage('Something went wrong while ending the session')
          );
      })
      .catch(() => {
        showErrorMessage('Current password does not match.');
        setIsLoading(false);
      });
  };
  const regex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^~])[A-Za-z\d@$!%*?&#^~]{0,}$/;
  const handleBox = () => {
    window.requestAnimationFrame(() => {
      window.scrollTo({
        top: 2000,
        behavior: 'auto',
      });
    });
    setShowBox(true);
  };

  const handleMembershipDelete = async () => {
    await deleteMembershipDelete()
      .then(() => {
        const userData = getItem('user');
        const accessToken = userData.accessToken;
        let loginCred: string = '';
        if (userData && userData.user) {
          const { userProfile, ...rest } = userData;
          removeItem('user');
          removeItem('userProfile');
          clear();
          ClearAllIndexedDB();
          if (userData && userData.user && userData.user.userEmail) {
            localStorage.setItem('email', userData.user.userEmail);
            loginCred = 'email';
          } else if (userData && userData.user && userData.user.userPhone) {
            localStorage.setItem('phonenumber', userData.user.userPhone);
            loginCred = 'phone';
          }
          localStorage.setItem('selectedHotel', selectedHotelId);
          localStorage.setItem('selectedClient', selectedClientId);
          showSuccessMessage('Membership deleted successfully');
          setTimeout(() => {
            logOutUser(accessToken)
              .then((res) => {
                navigate('/register-success/delete');
              })
              .catch((err) =>
                showErrorMessage(
                  'Something went wrong while ending the session'
                )
              );
          }, 1000);
        } else {
          setTimeout(() => {
            clear();
            ClearAllIndexedDB();
            localStorage.setItem('selectedHotel', selectedHotelId);
            localStorage.setItem('selectedClient', selectedClientId);
            window.location.href = '/login';
          }, 1000);
        }
      })
      .catch(() => {
        showErrorMessage('Something went wrong in Membership deletion');
      });
  };

  const dropdownOptions: IDropdownOption[] = [];
  {
    if (userData && userData.user && userData.user.userEmail) {
      dropdownOptions.push({
        value: userData.user.userEmail,
        label: userData.user.userEmail,
      });
    }
  }
  {
    if (userData && userData.userProfile && userData.userProfile.userEmail) {
      dropdownOptions.push({
        value: userData.userProfile.userEmail,
        label: userData.userProfile.userEmail,
      });
    }
  }
  {
    if (userData && userData.user && userData.user.userPhone) {
      dropdownOptions.push({
        value: userData.user.userPhone,
        label: userData.user.userPhone,
      });
    }
  }

  return (
    <div className="security-container">
      <div className="back-container">
        <div className="centered-element">
          <Icon
            height={20}
            width={20}
            kind="arrow-left"
            onClick={() => {
              navigate('/pilotwelcome');
            }}
          />
          <span className="fw-400 f-22 lh-28 color-1F1F1F ml-10">Security</span>
        </div>
      </div>
      <div className="d-flex align-items-center ml-10">
        <Icon kind="security-lock" height={22} width={20} />
        <span className="fw-600 f-20 lh-25 color-1F1F1F ml-15">Settings</span>
      </div>
      <div className="border-ui">
        <div className="setting-container mtn-20px box-shadow nice-border mb-20">
          <h1 className="fw-600 f-22 lh-28 color-1F1F1F">Change Password</h1>
          <span className="mt-10">
            <Icon
              height={18}
              width={18}
              kind={showPassword ? 'arrow-down' : 'arrow-right'}
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            />
          </span>
        </div>
        {showPassword && (
          <div className="display-gap email-wrapper">
            {(!userLoginPhone && !isEmailExist) ? (
              <DropdownSingle
                options={dropdownOptions}
                placeholder={'Choose email or phone to change password'}
                isClearable={false}
                callback={(e) => setIsEmailSelected(e.value)}
              />
            ) : isEmailExist ? (
              <ControlInput
                label=""
                name="password"
                value={userLoginEmail}
                disabled={true}
              />
            ) : (
              userLoginPhone && (
                <PhoneContainer>
                  <PhoneInput
                    country={'us'}
                    value={String(userLoginPhone)}
                    dropdownClass={'phone-input-dropdown'}
                    containerClass={'phone-input-dropdown'}
                    countryCodeEditable={false}
                    disabled={userLoginPhone}
                  />
                </PhoneContainer>
              )
            )}
            <TextInput
              title={t(
                'COMMON.MY_AUDIT.PAGES.PLACEHOLDERS.ENTER_CURRENT_PASSWORD'
              )}
              textValue={currentPassword}
              placeholder={t(
                'COMMON.MY_AUDIT.PAGES.PLACEHOLDERS.ENTER_CURRENT_PASSWORD'
              )}
              onValueChange={(value) => {
                setCurrentPassword(value);
              }}
              inputType="password"
              disabled={false}
            />
            <div className="security-change-password-container mln-10px mrn-10px">
              <TextInput
                title={t(
                  'COMMON.MY_AUDIT.PAGES.PLACEHOLDERS.ENTER_NEW_PASSWORD'
                )}
                textValue={newPassword}
                placeholder={t(
                  'COMMON.MY_AUDIT.PAGES.PLACEHOLDERS.ENTER_NEW_PASSWORD'
                )}
                isError={
                  newPassword.length > 7 && currentPassword == newPassword
                }
                onValueChange={(value) => {
                  setNewPassword(value);
                }}
                errorMessage={
                  newPassword.length > 7 && currentPassword == newPassword
                    ? `${t('COMMON.LOGIN.PASSWORD.ERROR.SAME_NEW_PASSWORD')}`
                    : ''
                }
                inputType="password"
                disabled={false}
              />
              <TextInput
                title={t(
                  'COMMON.MY_AUDIT.PAGES.PLACEHOLDERS.CONFIRM_NEW_PASSWORD'
                )}
                textValue={confirmNewPassword}
                placeholder={t(
                  'COMMON.MY_AUDIT.PAGES.PLACEHOLDERS.CONFIRM_NEW_PASSWORD'
                )}
                onValueChange={(value) => {
                  setConfirmNewPassword(value);
                }}
                inputType="password"
                disabled={false}
              />
              <div>
                <Icon
                  kind={newPassword.length > 7 ? 'status-success' : 'clear'}
                  width={13}
                  height={13}
                />
                <span className="fw-400 f-15 lh-20 color-979797">
                  {' '}
                  Password should be at least 8 Character long{' '}
                </span>
              </div>
              <div>
                <Icon
                  kind={regex.test(newPassword) ? 'status-success' : 'clear'}
                  width={13}
                  height={13}
                />
                <span className="fw-400 f-15 lh-20 color-979797">
                  {' '}
                  Uppercase, Letters, Numbers and Special Characters{' '}
                </span>
              </div>
              <div>
                <Icon
                  kind={
                    newPassword && newPassword === confirmNewPassword
                      ? 'status-success'
                      : 'clear'
                  }
                  width={13}
                  height={13}
                />
                <span className="fw-400 f-15 lh-20 color-979797">
                  {' '}
                  Password Must Match{' '}
                </span>
              </div>
            </div>
            <ButtonSaveContainer>
              <ButtonLarge
                onClick={() => {
                  handleSave();
                }}
                loading={isLoading}
                title={t('COMMON.OUTSIDE.BUTTONS.SAVE')}
                outlined={true}
                inverted={true}
                disabled={
                  !isPasswordValidated ||
                  isLoading ||
                  !currentPassword ||
                  currentPassword == newPassword
                }
              />
            </ButtonSaveContainer>
          </div>
        )}
        <div className="mt-20">
          {membershipCode && personalEmail && (
            <MemberShipDeleteButton handleBox={handleBox} />
          )}
          <div className="box-container">
            {showBox && (
              <Block className="delete box-shadow d-block m-7">
                <h1 className="sans-font font-normal fw-600 f-17 lh-22 text-center color-black">
                  Sure you want to delete you myLQA Membership?
                </h1>
                <span className="delete-text mt-0 sans-font">
                  This will delete all your data associated with your myLQA
                  membership. This action is irreversible.
                </span>
                <ButtonContainer>
                  <ButtonBlockRow>
                    <ButtonMedium
                      title="No, Go Back"
                      onClick={() => setShowBox(false)}
                      inverted={true}
                      outlined={true}
                    />
                    <ButtonMedium
                      title="Yes, Delete"
                      backgroundColor="rustyRed"
                      textColor="white"
                      onClick={() => handleMembershipDelete()}
                    />
                  </ButtonBlockRow>
                </ButtonContainer>
              </Block>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
